const t = "kioskButton_kC6jr", o = {
  kioskButton: t
};
export {
  o as default,
  t as kioskButton
};
//# sourceMappingURL=kioskButton.module.scss.js.map
